import { render, staticRenderFns } from "./CourseBuyDesktop.vue?vue&type=template&id=1f083431&scoped=true"
import script from "./CourseBuyDesktop.vue?vue&type=script&lang=js"
export * from "./CourseBuyDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f083431",
  null
  
)

export default component.exports